import { render, staticRenderFns } from "./ed-button-icon.vue?vue&type=template&id=1f9db3d8&scoped=true&"
import script from "./ed-button-icon.ts?vue&type=script&lang=ts&"
export * from "./ed-button-icon.ts?vue&type=script&lang=ts&"
import style0 from "./ed-button-icon.scss?vue&type=style&index=0&id=1f9db3d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9db3d8",
  null
  
)

export default component.exports